import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import IsoDate from '../types/IsoDate';
import RequestMetadata from './RequestMetadata';


const Inquiry = types
    .model('Inquiry', {
        id: types.optional(types.identifier, () => uuid()),
        date: IsoDate,

        experiments: types.optional(types.map(types.integer), {}), // map of segments
        source: types.optional(types.string, 'Ratehub'),

        request: types.optional(RequestMetadata, {}),
    });

export default Inquiry;
